import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {GAProvider} from '@perion-undertone/ut-react-common';

/**
 * Replaces ut-react-common GoogleAnalyticsPageView, which still calls
 * GAProvider.event() — that API was removed when GAProvider moved to react-ga4.
 */
export default class GoogleAnalyticsRouteListener extends React.Component {
    componentDidUpdate(prevProps) {
        const {location} = this.props;
        if (prevProps.location.pathname !== location.pathname) {
            if (typeof GAProvider.pageView === 'function') {
                GAProvider.pageView(location.pathname);
            }
            if (_.isFunction(this.props.locationChanged)) {
                this.props.locationChanged(location);
            }
        }
    }

    render() {
        return null;
    }
}

GoogleAnalyticsRouteListener.propTypes = {
    location: PropTypes.object.isRequired,
    locationChanged: PropTypes.func
};
